/* The one piece of inline formatting the guide model understands: **double asterisks** mark a bold
   run. parseInline() splits a string into ordered segments for the React renderer; stripInline()
   drops the markers for the PDF, whose body text is a single weight. */

export interface InlineSegment {
  text: string;
  bold: boolean;
}

export function parseInline(text: string): InlineSegment[] {
  const segments: InlineSegment[] = [];
  const re = /\*\*(.+?)\*\*/g;
  let last = 0;
  let match: RegExpExecArray | null;
  while ((match = re.exec(text)) !== null) {
    if (match.index > last) segments.push({ text: text.slice(last, match.index), bold: false });
    segments.push({ text: match[1], bold: true });
    last = match.index + match[0].length;
  }
  if (last < text.length) segments.push({ text: text.slice(last), bold: false });
  return segments;
}

export const stripInline = (text: string): string => text.replace(/\*\*(.+?)\*\*/g, '$1');
